const news = [
  {
    year: "2024",
    month: "10",
    day: "11",
    tit: "第二届霍尔果斯欧亚金融和经济论坛在中哈霍尔果斯国际边境合作中心举行",
    txt: "习近平总书记在第三届“一带一路”国际合作高峰论坛上指出，中方将同共建“一带一路”各国加强能源、金融、绿色发展、文化等领域的多边合作平台建设，完善“一带一路”国际合作机制。10月11日，第二届霍尔果斯欧亚金融和经济论坛在中哈霍尔果斯国际边境合作中心中国文化馆举行，本次论坛以“东西方—商业无国界”为主题，汇聚了30多个国家和地区的350余名金融和经济领域的精英，共同探讨欧亚金融与经济的未来发展趋势与合作机遇。",
    txtJson: [
      "论坛期间，来自中国、俄罗斯、哈萨克斯坦的多位专家学者及行业精英发表了精彩演讲，分享了他们对金融和经济领域的深刻见解与前瞻性预测，充分展示了欧亚大陆各国在金融经济领域的巨大合作潜力与发展空间。",
      "中哈霍尔果斯国际边境合作中心管理办公室主任王丽娟和哈萨克斯坦霍尔果斯国际边境合作中心国家股份管理公司代理主席库尔马舍夫·叶尔然·赛诺维奇分别介绍了合作中心中哈双方区域情况，增强与会嘉宾对合作中心的了解与认识。",
      "论坛还设置了专题过论和展示环节。与会嘉宾围绕金融创新、经济发展等核心议题展开了热烈而深入的讨论，共同感受各国在金融经济领域的最新成果与进展。",
      "由杭州电建股权投资有限公司、Zantech  Limited及霍尔果斯丝路科技服务有限公司联合发起的中哈人民币结算及跨境支付项目——KZPAY，备受瞩目。该项目的成功落地，标志着中哈两国在跨境支付领域的重大创新突破，将成为推动两国数字经济深度融合的重要引擎，进一步加强金融合作，为构建更加高效、安全的跨境支付生态体系提供强有力的支持，为区域经济的增长以及人民币的国际化进程作出积极贡献。",
      "近年来，霍尔果斯积极融入丝绸之路经济带建设，充分发挥区位、政策、开放等优势，依托中哈霍尔果斯国际边境合作中心、中国(新疆)自由贸易试验区霍尔果斯片区等平台，深化与周边国家的交流与合作，成功举办了多项国际活动，并与哈萨克斯坦潘菲洛夫区建立了友好城市关系，达成了多项合作机制与共识。霍尔果斯开放的大门越开越大，已成为通往中亚、西亚、欧洲等地的“黄金通道”和国家地区间经贸合作的重要平台。",
      "霍尔果斯市政府党组成员、副市长雷增涛表示，随着全球化的深入推进和区域合作的不断加强，欧亚金融合作的重要性愈发凸显。霍尔果斯将围绕打造跨境经贸投资合作新样板，加快建设区域金融服务中心，积极探索离岸金融服务和创新，推进金融结算便利化，促进跨境资金高效流动，为双边贸易与投资活动提供更为优质的服务，助力共建“一带一路”国家实体经济蓬勃发展。",
    ],
    pic: "news-d2.jpg",
    video: "news-d2.mp4",
  },
  {
    year: "2024",
    month: "9",
    day: "10",
    tit: "促进中哈经贸合作，“数贸之夜”上，这两个项目签约",
    txt: "9月25日至29日，第三届全球数字贸易博览会在杭举行。在25日晚举行的“数贸之夜”活动中，科里扎特智慧化口岸项目、中哈人民币结算及跨境支付项目签约。",
    txtJson: [
      "杭州电建股权投资有限公司董事长吴瑞录，浙江电子口岸有限公司董事长孙华伟，Financial Holding Corporation Limited董事长Kozhametov Sabit先生签约科里扎特智慧化口岸项目。杭州电建股权投资有限公司总裁徐蕾，Zantech  Limited董事长黄自力以及哈萨克斯坦方代表签约中哈人民币结算及跨境支付项目。",
      "科里扎特智慧化口岸项目，是哈萨克斯坦第一次与中方进行全方面战略合作口岸建设。合作双方将加强数字经济、贸易、交通、运输和物流的战略对接，持续同步推进边境现有口岸的现代化改造，促进跨境通关便利化，开展国际贸易“单一窗口”互联互通，为双方经贸合作注入源源不断动力。 中哈人民币结算及跨境支付项目主要聚焦海外本地支付、人民币全球结算、全球互联互通钱包三大核心业务板块，各合作方将在杭州成立全球支付业务中心，致力于提升中哈乃至中亚、全球贸易效率。2023年，中哈两国贸易额达410亿美元，同比增长32%，中国已成为哈萨克斯坦第一大贸易伙伴国。",
    ],
    pic: "news-d1.png",
  },
];

export default news;



// WEBPACK FOOTER //
// ./src/view/newsJson.js